import { useTheme } from '../../hooks/useTheme'
import type { ReactNode } from 'react'

interface BadgeProps {
  children: ReactNode
  variant?: 'brand' | 'accent' | 'success' | 'info' | 'warning'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Badge({ 
  children, 
  variant = 'brand',
  size = 'sm',
  className = '' 
}: BadgeProps) {
  const theme = useTheme()
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2',
  }
  
  const variantStyles: Record<NonNullable<BadgeProps['variant']>, { backgroundColor: string; color: string }> = {
    brand: {
      backgroundColor: theme.brand.dark,
      color: theme.text.secondary,
    },
    accent: {
      backgroundColor: theme.accent.medium,
      color: theme.accent.text,
    },
    success: {
      backgroundColor: 'rgba(34, 197, 94, 0.15)',
      color: '#22c55e',
    },
    info: {
      backgroundColor: theme.accent.light,
      color: theme.accent.text,
    },
    warning: {
      backgroundColor: 'rgba(234, 179, 8, 0.2)',
      color: '#eab308',
    },
  }
  
  return (
    <div
      className={`font-bold rounded-lg inline-block ${sizeClasses[size]} ${className}`}
      style={variantStyles[variant]}
    >
      {children}
    </div>
  )
}
